<template>
  <div class="moow-master-container">
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <div v-else class="container">
      <b-row class="mt-3 mb-4">
        <b-col lg="3"></b-col>
        <b-col style="text-align: center;">
          <router-link to="/account">Looking for Landlord settings?</router-link>
          <moow-button
            :type="['light', 'wide']"
            btnText="Save"
            @mClick="save"
            :disabled="savingSettings"
          />
        </b-col>
        <b-col lg="3"></b-col>
      </b-row>
      <b-row class="mt-3 mb-4">
        <b-col lg="2" md="2" sm="1"></b-col>
        <b-col lg="9" md="10" sm="11">
          <md-card class="island-card pr-3">
            <md-card-content>
              <md-steppers md-vertical>
                <md-step
                  id="first"
                  md-label="Profile"
                  md-description="Name and contact information"
                >
                  <b-row class="mt-3">
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="First Name"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                      >
                        <b-form-input
                          :state="errors.has('first name')?false:null"
                          name="first name"
                          type="text"
                          v-model="firstName"
                          placeholder="Your name"
                          required
                        />
                        <span
                          v-show="errors.has('first name')"
                          class="help is-danger"
                        >{{ errors.first('first name') }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="Last Name"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                      >
                        <b-form-input
                          :state="errors.has('last name')?false:null"
                          name="last name"
                          type="text"
                          v-model="lastName"
                          placeholder="Your name"
                          required
                        />
                        <span
                          v-show="errors.has('last name')"
                          class="help is-danger"
                        >{{ errors.first('last name') }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="User Email"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                      >
                        <b-form-input
                          name="email"
                          type="text"
                          v-model="email"
                          placeholder="you@provider.domain"
                          required
                          :disabled="true"
                          :state="isEmailVerified"
                        />
                        <span
                          v-if="!isEmailVerified"
                          class="help is-danger"
                        >Verification link on email</span>
                        <p
                          v-if="!isEmailVerified"
                          @click="sendEmailVerification()"
                          class="help is-danger"
                          style="cursor:pointer"
                        >Send Again</p>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="Phone number"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                      >
                        <router-link to="/account">Contact details moved under account</router-link>
                        <!-- <b-form-input
                          v-if="loadingPhone"
                          class="mb-3"
                          :disabled="true"
                          placeholder="getting..."
                        ></b-form-input>
                        <b-form-input
                          v-else
                          class="mb-3"
                          v-model="phoneNumber"
                          placeholder="Specify phone number"
                          :state="errors.has('phone')?false:null"
                          name="phone"
                          type="text"
                        ></b-form-input>

                        <span
                          v-show="errors.has('phone')"
                          class="help is-danger"
                        >{{ errors.first('phone') }}</span> -->
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="Where You Based?"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                      >
                        <b-form-input
                          :state="errors.has('based')?false:null"
                          name="based"
                          type="text"
                          v-model="currentlyBased"
                          placeholder
                        />
                        <span
                          v-show="errors.has('based')"
                          class="help is-danger"
                        >{{ errors.first('based') }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="Describe Yourself "
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                        description="Moowle is built on relationships. Help other people get to know you. Tell others what it would be like to have you as a tenant or host."
                      >
                        <b-form-textarea
                          :state="errors.has('description')?false:null"
                          name="description"
                          type="text"
                          v-model="userDescription"
                          placeholder
                          :rows="3"
                        ></b-form-textarea>
                        <span
                          v-show="errors.has('description')"
                          class="help is-danger"
                        >{{ errors.first('description') }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="Preferred Language "
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                        description="We'll send you messages in this language."
                      >
                        <b-form-input
                          :state="errors.has('language')?false:null"
                          name="language"
                          type="text"
                          v-model="userPrefLanguage"
                          placeholder
                        ></b-form-input>
                        <span
                          v-show="errors.has('language')"
                          class="help is-danger"
                        >{{ errors.first('language') }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="Workplace"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                        description="Let the host or tenant know about your background"
                      >
                        <b-form-input
                          :state="errors.has('workplace')?false:null"
                          name="language"
                          type="text"
                          v-model="userWorkplace"
                        ></b-form-input>
                        <span
                          v-show="errors.has('workplace')"
                          class="help is-danger"
                        >{{ errors.first('workplace') }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </md-step>

                <md-step id="second" md-label="Photos">
                  <b-row class="mt-3">
                    <b-col lg="4">
                      <!-- <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="upload" :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload">
                      <md-avatar class="mo-xlarge avatar-uploader">
                        <img v-if="imageUrl" :src="imageUrl" />
                        <img v-else :src="avatarPlaceholder" />
                        <div class="avatar-overhover mo-xlarge"><span class="change-avatar-peek">+</span></div>
                      </md-avatar>
                      </el-upload>-->
                      <md-avatar class="mo-xlarge avatar-uploader">
                        <img v-if="loadingAvatar" :src="loaderIcon" />
                        <img v-else-if="imageUrl" :src="imageUrl" />
                        <img v-else :src="avatarPlaceholder" />
                        <div class="avatar-overhover mo-xlarge">
                          <span class="change-avatar-peek">+</span>
                        </div>
                      </md-avatar>
                    </b-col>
                    <b-col>
                      <b-row>
                        <p>Clear frontal face photos are an important way for hosts and guests to learn about each other. Be sure to use a photo that clearly shows your face and doesn’t include any personal or sensitive info.</p>
                      </b-row>
                      <b-row>
                        <el-upload
                          action
                          :show-file-list="false"
                          :http-request="upload"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload"
                        >
                          <moow-button :type="['dark', 'outlined', 'wide']" btnText="Upload new" />
                          <!-- <b-button
                              style="width:100%"
                              variant="outline"
                          >Upload new</b-button>-->
                        </el-upload>
                      </b-row>
                    </b-col>
                  </b-row>
                </md-step>
                <md-step
                  id="third"
                  :md-label="verificationLable"
                  :class="{ verified: verifiedUser, notVerified:!verifiedUser }"
                >
                  <p>
                    <strong>Email</strong>
                  </p>
                  <b-row v-if="isEmailVerified" class="mt-3">
                    <b-col lg="3"></b-col>
                    <b-col>
                      <b-form-input
                        name="email"
                        type="text"
                        placeholder="verified"
                        :disabled="true"
                        :state="isEmailVerified"
                      />
                    </b-col>
                    <b-col lg="3"></b-col>
                  </b-row>
                  <b-row v-else class="mt-3">
                    <b-row>
                      <b-col lg="3"></b-col>
                      <b-col lg="9">
                        <b-row>
                          <b-col>
                            <div class="mo-no-check"></div>Verify your email!
                          </b-col>
                          <b-col>
                            <p
                              v-if="emailSentThisSession"
                            >Click verification link on email and save this page.</p>
                            <b-button
                              v-else
                              style="width:100%"
                              variant="outline-primary"
                              @click="sendEmailVerification()"
                            >Send verification link</b-button>
                          </b-col>
                        </b-row>
                        <b-row>
                          <i>A confirmed email is important to allow us to securely communicate with you. We won’t share your private email address with other Moowle users.</i>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-row>
                  <hr class="hr-form-el-separator" />
                  <p>
                    <strong>Social Accounts</strong>
                  </p>
                  <!--  GOOGLE -->
                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="googleLink"
                        horizontal
                        breakpoint="lg"
                        label="Google"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                      >
                        <b-form-input
                          v-if="googleLinked"
                          name="email"
                          type="text"
                          placeholder="connected"
                          :disabled="true"
                          :state="googleLinked"
                        />
                        <moow-button
                          v-else
                          :type="['dark', 'outlined']"
                          btnText="Connect Google"
                          @mClick="linkGoogle"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!--  FACEBOOK -->
                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="facebookLink"
                        horizontal
                        breakpoint="lg"
                        label="Facebook"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                      >
                        <b-form-input
                          v-if="facebookLinked"
                          name="email"
                          type="text"
                          placeholder="connected"
                          :disabled="true"
                          :state="facebookLinked"
                        />
                        <moow-button
                          v-else
                          :type="['dark', 'outlined']"
                          btnText="Connect Facebook"
                          @mClick="linkFacebook"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!--  LINKEDIN -->
                  <b-row>
                    <b-col lg="9" class="text-right pr-0">
                      <b-form-group
                        id="fieldsetHorizontal"
                        horizontal
                        breakpoint="lg"
                        label="Linked In"
                        :label-cols="4"
                        label-for="inputHorizontal"
                        align="right"
                      >
                        <b-form-input
                          class="mb-3"
                          v-model="linkedIn"
                          placeholder="Copy public LinkedIn URL here to link"
                          :state="errors.has('linkedin')?false:null"
                          name="linkedin"
                          type="text"
                        ></b-form-input>
                        <span
                          v-show="errors.has('linkedin')"
                          class="help is-danger"
                        >{{ errors.first('linkedin') }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </md-step>
              </md-steppers>
            </md-card-content>
          </md-card>
        </b-col>
      </b-row>

      <b-row v-if="changePass" class="mb-2">
        <b-col lg="3"></b-col>
        <b-col lg="2"></b-col>
        <b-col lg="4" class="text-right">
          <a href="#" v-b-modal.modal1>Change password</a>
        </b-col>
        <b-col lg="3"></b-col>
      </b-row>
      <b-modal id="modal1" ref="myModal" title="Password" @ok="changePassword">
        <b-form @submit="changePassword">
          <b-row class="mb-2">
            <b-col lg="3"></b-col>
            <b-col>
              <b-form-group breakpoint="lg" class="mb-0">
                <b-form-input
                  class="mb-3"
                  v-model="oldPass"
                  type="password"
                  placeholder="Old Password"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="3"></b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col lg="3"></b-col>
            <b-col>
              <b-form-group breakpoint="lg" class="mb-0">
                <b-form-input
                  class="mb-3"
                  v-model="newPass"
                  type="password"
                  placeholder=" New Password"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="3"></b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col lg="3"></b-col>
            <b-col>
              <b-form-group breakpoint="lg" class="mb-0">
                <b-form-input
                  class="mb-3"
                  type="password"
                  v-model="newPass1"
                  placeholder="Re-enter new Password"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="3"></b-col>
          </b-row>
          <input type="submit" style="display: none" />
        </b-form>
      </b-modal>

      <b-row class="mt-3 mb-4">
        <b-col lg="3"></b-col>
        <b-col>
          <moow-button
            v-if="!loading"
            :type="['dark', 'outlined', 'flat', 'wide']"
            btnText="Preview Profile"
            @mClick="navigateToUserProfile"
          />
        </b-col>
        <b-col lg="3"></b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { updateUser, getCurrentUser } from "../users/services/userService.js";
import {
  uploadProfileImage,
  getUserUid,
  getUserToken,
} from "../functions.js";
import { isUserMoowleVerified } from "../users/repositories/userRepository.js";
import { getCurrentFirebaseUser } from "@/platform/auth/services/authService.js";
export default {
  name: "settings",
  data() {
    return {
      savingSettings: false,
      loadingAvatar: false,
      loading: false,
      loadingText: "",
      firstName: "",
      lastName: "",
      email: "",
      oldPass: "",
      newPass: "",
      newPass1: "",
      areaCode: "",
      phoneNumber: "",
      changePass: true,
      imageUrl: "",
      avatarPlaceholder: "../static/avatar.png",
      loadingPhone: false,
      isEmailVerified: false,
      userDescription: "",
      currentlyBased: "",
      userPrefLanguage: "",
      userWorkplace: "",
      linkedIn: "",
      googleLinked: false,
      facebookLinked: false,
      maaklerId: undefined,
      emailSentThisSession: false,
      verifChangesMade: false,
      verifiedUser: false,
    };
  },
  async created() {
    this.$emit("emitChangeViewTitle", "My Profile");
    this.loading = true;
    let user = this.currentFirebaseUser;
    if (user && !user.isAnonymous) {
      if (user.providerData[0].providerId != "password")
        this.changePass = false;

      this.isEmailVerified = user.emailVerified;
      if (!this.isEmailVerified)
        this.notifyUser("Verify Email", "Verification link on email");
      this.email = user.email;
      let imgUrl = user.photoURL;
      if (imgUrl && imgUrl != "" && imgUrl != "null") {
        this.imageUrl = imgUrl;
      }
      this.loadingPhone = true;
      const userReply = await getCurrentUser(user.uid)
      if(!userReply) {
        this.loadingPhone = false;
        this.loading = false;
      }else {
        this.verifiedUser = isUserMoowleVerified(userReply);
        let phoneNr = userReply.phone;
        if (phoneNr && phoneNr != "" && phoneNr != "null")
          this.phoneNumber = phoneNr;
        this.loadingPhone = false;
        userReply.maaklerID ? (this.maaklerId = userReply.maaklerID) : void 0;
        userReply.firstName ? (this.firstName = userReply.firstName) : void 0;
        userReply.lastName ? (this.lastName = userReply.lastName) : void 0;
        userReply.description
          ? (this.userDescription = userReply.description)
          : void 0;
        userReply.currentlyBased
          ? (this.currentlyBased = userReply.currentlyBased)
          : void 0;
        userReply.prefLanguage
          ? (this.userPrefLanguage = userReply.prefLanguage)
          : void 0;
        userReply.workplace
          ? (this.userWorkplace = userReply.workplace)
          : void 0;
        userReply.linkedInPublicUrl
          ? (this.linkedIn = userReply.linkedInPublicUrl)
          : void 0;
        this.loading = false;
      }
        
      for (let provider of user.providerData) {
        if (provider.providerId == "google.com") this.googleLinked = true;
        if (provider.providerId == "facebook.com") this.facebookLinked = true;
      }
    }
  },
  computed: {
    verificationLable: function () {
      if (this.verifiedUser) return "Verification (verified)";
      else return "Verification";
    },
    loaderIcon() {
      return require("../assets/loader-rolling.svg");
    },
    currentFirebaseUser() {
      return getCurrentFirebaseUser()
    },
  },
  methods: {
    sendEmailVerification() {
      this.currentFirebaseUser.sendEmailVerification();
      this.notifyUser("Link sent", "Confirm email and refresh");
      this.emailSentThisSession = true;
      this.verifChangesMade = true;
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
    navigateToUserProfile() {
      try {
        var userMaakId = Number(this.maaklerId);
        this.$router.push({ name: "user", params: { id: userMaakId } });
      } catch (err) {
        this.$notify({
          title: "Uh oh",
          message: "Something's not right",
        });
      }
    },
    linkFacebook() {
      var self = this;
      this.currentFirebaseUser
        .linkWithPopup(new firebase.auth.FacebookAuthProvider())
        .then((result) => {
          self.facebookLinked = true;
          // Accounts successfully linked.
          var credential = result.credential;
          var user = result.user;
          return true;
        })
        .catch(function (error) {
          self.facebookLinked = false;
          return false;
        });
      this.verifChangesMade = true;
    },
    linkGoogle() {
      var provider = new firebase.auth.GoogleAuthProvider();
      this.googleLinked = this.currentFirebaseUser
        .linkWithPopup(provider)
        .then(function (result) {
          // Accounts successfully linked.
          this.googleLinked = true;
          var credential = result.credential;
          var user = result.user;
          return true;
          // ...
        })
        .catch(function (error) {
          this.googleLinked = false;
          return false;
          // Handle Errors here.
          // ...
        });
      this.verifChangesMade = true;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("Image must be JPEG format.");
      }
      if (!isLt2M) {
        this.$message.error("Max phoyo size is 2MB");
      }
      return isJPG && isLt2M;
    },
    changePassword(e) {
      e.preventDefault();
      this.loading = true;
      this.loadingText = "Changing password";
      var user = this.currentFirebaseUser;
      let cred = firebase.auth.EmailAuthProvider.credential(
        this.email,
        this.oldPass
      );
      // Prompt the user to re-provide their sign-in credentials
      user
        .reauthenticateWithCredential(cred)
        .then((res) => {
          return user.updatePassword(this.newPass);
        })
        .then((res) => {
          this.$refs.myModal.hide();
          this.$notify({
            title: "Notification",
            message: "Success change password",
          });
          this.loading = false;
        })
        .catch(function (error) {
          this.$notify({
            title: "Notification",
            message: "Error change password",
          });
          this.loading = false;
        });
    },
    save() {
      var validationReport = this.validateForm();
      if (validationReport.success) this.updateUser();
      else this.notifyUser("Missing required fields", validationReport.result);
    },
    validateForm() {
      var success = true;
      var result = "";
      if (!this.firstName) {
        result += "First name, ";
        success = false;
      }
      if (!this.lastName) {
        result += "Last name";
        success = false;
      }

      return {
        success: success,
        result: result,
      };
    },
    updateUser() {
      this.savingSettings = true;
      let user = this.currentFirebaseUser;
      this.isEmailVerified = user.emailVerified;
      this.verifChangesMade = false;
      // locally
      this.$store.commit("SET_USER_PIC_URL", this.imageUrl);

      // firebase
      user
        .updateProfile({
          displayName: this.firstName,
          photoURL: this.imageUrl,
        })
        .then((res) => {
          sessionStorage.setItem("liu_displayname", this.firstName);
          sessionStorage.setItem("liu_email", this.email);
          sessionStorage.setItem("liu_photoURL", this.imageUrl);
          sessionStorage.setItem("liu_phoneNumber", this.phoneNumber);

          var userUpdates = this.makeUserUpdatesFromForm();
          // database
          updateUser(getUserUid(), userUpdates);
          this.savingSettings = false;
          this.$notify({
            title: "Saved",
            message: "Profile updated",
          });
        })
        .catch((err) => {
          this.savingSettings = false;
          this.$notify({
            title: "Notification",
            message: "Profile update failed",
          });
        });
    },
    makeUserUpdatesFromForm() {
      return {
        firstName: this.capitalize(this.firstName),
        lastName: this.capitalize(this.lastName),
        email: this.email,
        pictureUrl: this.imageUrl,
        phone: this.phoneNumber,
        description: this.userDescription,
        currentlyBased: this.currentlyBased,
        prefLanguage: this.userPrefLanguage,
        workplace: this.userWorkplace,
        linkedInPublicUrl: this.linkedIn,
        emailVerified: this.isEmailVerified,
        googleLinked: this.googleLinked,
        facebookLinked: this.facebookLinked,
      };
    },
    upload(file) {
      const h = this.$createElement;
      this.loadingAvatar = true;
      const formData = new FormData();
      formData.append("photo", file.file);
      formData.append("token", getUserToken());
      uploadProfileImage(formData)
        .then((resp) => {
          this.imageUrl = resp.body;
          this.updateUser();
          this.loadingAvatar = false;
        })
        .catch((err) => {
          this.loadingAvatar = false;
          this.$notify({
            title: "Notification",
            message: h(
              "i",
              {
                style: "color: teal",
              },
              "Something is not right"
            ),
          });
        });
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
<style>
@import "../assets/styles/global.css";

/* .el-upload--picture-card {
    border-radius: 100px
  }
.el-icon-delete{
    display: none
} */

.avatar-uploader .el-upload {
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader .el-upload:hover .avatar-overhover {
  display: inline;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  border-radius: 150px;
  width: 150px;
  height: 150px;
  /* display: block; */
}
.avatar-overhover {
  display: none;
  position: absolute;
  background-color: rgb(255, 255, 255, 0.6);
}

.change-avatar-peek {
  position: absolute;
  z-index: 9999;
  top: 45%;
  left: 43%;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue